import React from 'react';

import FullPageQuizQuestion from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';
import FullPageQuizTextInput from 'dpl/components/FullPageQuiz/FullPageQuizTextInput';
import useFormContext from 'dpl/shared/form/hooks/useFormContext';
import { get } from 'dpl/shared/utils/object';
import useCurrentUser from 'dpl/common/hooks/useCurrentUser';

import useInitialInquiry from '../hooks/useInitialInquiry';
import { FORM_MESSAGE_TEXT_NAME } from '../utils/constants';

export default function QuizMessageQuestion(props) {
  const { breederProfile, currentPuppy } = useInitialInquiry();
  const { formState, addToFormState, handleLoginClick } = useFormContext();
  const currentUser = useCurrentUser();

  const { name: programName } = breederProfile;
  const { name: puppyName } = currentPuppy;

  const message = get(formState, FORM_MESSAGE_TEXT_NAME, '');

  return (
    <>
      <FullPageQuizQuestion
        className="InitialInquiryQuizMessageQuestion"
        title={`Find out more about ${puppyName}`}
        subtitle={`Send a request to ${breederProfile.user.first_name} at ${programName} to learn more about ${puppyName}. Personalize your message so ${breederProfile.user.first_name} can start getting to know you.`}
        newDesignSystemStyles
        {...props}
      >
        <FullPageQuizTextInput
          Tag="textarea"
          id={FORM_MESSAGE_TEXT_NAME}
          className="no-resize"
          name={FORM_MESSAGE_TEXT_NAME}
          value={message}
          onChange={e => addToFormState(FORM_MESSAGE_TEXT_NAME, e.target.value)}
          newDesignSystemStyles
        />
      </FullPageQuizQuestion>
      {!currentUser.isLoggedIn && (
        <p className="mt20 mh8 tc f2 secondary">
          Already have an account?{' '}
          <button
            className="royal-blue link--primary"
            onClick={handleLoginClick}
            type="button"
          >
            Log in
          </button>
        </p>
      )}
    </>
  );
}
